
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import NavHeader from "@/components/semantics/KunMingHeader.vue";
import Footer from "@/components/semantics/Footer.vue";
// import Footer from '@components/footer/Footer.vue';
@Component({
  name: 'StationKunMing',
  components: {
    NavHeader,
    Footer,
  },
})
export default class StationKunMing extends Vue {
  isOverflow: any = true;
  mounted() {
    const pcm = document.getElementById("pcm");
    // (pcm as any).
    (pcm as any).addEventListener("scroll", () => {
      this.isOverflow = false;
    })
  }
  @Watch("$route", {immediate: true})
  handleChange() {
    this.isOverflow = true;
  }
}
